import React from 'react';
import { Modal, Spin, Table, Tooltip } from 'antd';

type ScheduleDetailModalProps = {
    visible: boolean;
    loading?: boolean;
    task: any;
    items: any[];
    onCancel: () => void;
};

const displayValue = (value?: string | number | null) => {
    if (value === undefined || value === null || value === '') {
        return '—';
    }
    return value;
};

const renderEllipsis = (text?: string | null) => {
    const value = text != null && String(text).trim() !== '' ? String(text).trim() : '';
    if (!value) {
        return '';
    }
    return (
        <Tooltip title={value} placement="topLeft">
            <span className="shelf-rule__cell-ellipsis">{value}</span>
        </Tooltip>
    );
};

export const ScheduleDetailModal = ({
    visible,
    loading,
    task,
    items,
    onCancel,
}: ScheduleDetailModalProps) => {
    const dim = task?.dimension === 'SKU' ? 'SKU' : 'SPU';

    const columns = [
        {
            title: `${dim}编码`,
            dataIndex: 'objectCode',
            key: 'objectCode',
            width: 160,
        },
        {
            title: '名称',
            dataIndex: 'objectName',
            key: 'objectName',
        },
        {
            title: '上架端',
            dataIndex: 'shelfResult',
            key: 'shelfResult',
            width: 100,
        },
        {
            title: '下架端',
            dataIndex: 'unshelfResult',
            key: 'unshelfResult',
            width: 100,
        },
        {
            title: '原因',
            dataIndex: 'reason',
            key: 'reason',
            width: 180,
            className: 'shelf-rule__ellipsis-col',
            render: (text: string) => renderEllipsis(text),
        },
    ];

    return (
        <Modal
            title="定时任务详情"
            visible={visible}
            footer={null}
            onCancel={onCancel}
            width={860}
            destroyOnClose
            wrapClassName="shelf-rule-detail-modal"
        >
            <Spin spinning={!!loading}>
                <table className="shelf-rule__detail-desc">
                    <tbody>
                        <tr>
                            <th>定时任务名称</th>
                            <td>{displayValue(task?.name)}</td>
                            <th>维度</th>
                            <td>{displayValue(task?.dimension)}</td>
                        </tr>
                        <tr>
                            <th>上架时间</th>
                            <td>{displayValue(task?.onTime)}</td>
                            <th>下架时间</th>
                            <td>{displayValue(task?.offTime)}</td>
                        </tr>
                        <tr>
                            <th>状态</th>
                            <td>{displayValue(task?.status)}</td>
                            <th>说明</th>
                            <td>{displayValue(task?.remark)}</td>
                        </tr>
                    </tbody>
                </table>
                <Table
                    className="shelf-rule__detail-table"
                    rowKey={(record, index) => String(record.id || record.objectCode || index)}
                    columns={columns}
                    dataSource={items}
                    pagination={false}
                    size="middle"
                    bordered
                    scroll={{ y: 360 }}
                />
            </Spin>
        </Modal>
    );
};
